/**
 * Field-notes section head: a SECT. mark, the title, and a rule to the margin.
 * The number is the reading order of the document, so it carries the same
 * information as a page number rather than decorating the heading.
 */
export default function SectionHead({
  mark,
  title,
  note,
  onDark = false,
}: {
  mark: string
  title: string
  note?: string
  onDark?: boolean
}) {
  return (
    <div className="mb-8">
      <div className={`sect-head ${onDark ? 'border-stone/60' : ''}`}>
        <span className={`sect-mark ${onDark ? 'text-golden' : ''}`}>{mark}</span>
        <h2
          className={`hl hl-fit text-[clamp(1rem,3.2vw,2rem)] min-w-0 ${onDark ? 'text-stone' : ''}`}
        >
          {title}
        </h2>
      </div>
      {note && (
        <p
          className={`descriptor text-base md:text-lg max-w-2xl -mt-4 ${
            onDark ? 'text-stone/70' : 'text-navy/70'
          }`}
        >
          {note}
        </p>
      )}
    </div>
  )
}
